module.exports = __webpack_public_path__ + "media/36.7aec45b2.wav";